import React, { useEffect } from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" sx={{ fontWeight: 700, color: '#1B1464', mb: 1.5, fontSize: { xs: '1rem', md: '1.25rem' } }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const Para = ({ children }) => (
  <Typography variant="body2" sx={{ color: '#444', lineHeight: 1.9, mb: 1.5, fontSize: { xs: '0.85rem', md: '0.95rem' } }}>
    {children}
  </Typography>
);

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: '#FBF9F7', minHeight: '100vh', py: { xs: 3, md: 6 } }}>
      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            fontWeight: 700,
            color: '#1A1A2E',
            mb: 1,
            fontSize: { xs: '1.6rem', sm: '2rem', md: '2.5rem' },
          }}
        >
          Privacy Policy
        </Typography>

        <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
          <Para>
            Valli Velli Maligai ("we", "our", or "us") operates the website vallivelimaligai.in.
            By using our Website, you agree to the collection and use of information in accordance with this policy.
          </Para>

          <Divider sx={{ my: 3 }} />

          <Section title="1. Information We Collect">
            <Para>
              • Name, email, phone number, and address provided via contact or order forms.<br />
              • Browser type, IP address, and pages visited (collected automatically via cookies).
            </Para>
          </Section>

          <Section title="2. How We Use Your Information">
            <Para>
              • To process orders and respond to inquiries.<br />
              • To improve our Website and services.<br />
              • To send updates or offers (you may opt out anytime).
            </Para>
          </Section>

          <Section title="3. Cookies">
            <Para>
              We use cookies to improve your experience. You can disable cookies in your browser settings.
            </Para>
          </Section>

          <Section title="4. Data Sharing">
            <Para>
              We do not sell your personal data. We may share information with service providers who help
              operate our Website, or when required by law.
            </Para>
          </Section>

          <Section title="5. Data Security">
            <Para>
              We use reasonable measures to protect your information. However, no method of online
              transmission is 100% secure.
            </Para>
          </Section>

          <Section title="6. Your Rights">
            <Para>
              You may request access, correction, or deletion of your personal data by contacting us.
            </Para>
          </Section>

          <Section title="7. Changes">
            <Para>
              We may update this policy from time to time. Changes will be posted on this page.
            </Para>
          </Section>

          <Section title="8. Contact Us">
            <Para>
              <strong>Valli Velli Maligai</strong><br />
              Vengamedu, Karur District, Tamil Nadu, India<br />
              Phone: +91 6382939365<br />
              Email: info@vallivelli.com
            </Para>
          </Section>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
